import {
    CButton,
    CModal,
    CModalBody,
} from "@coreui/react";
import * as Yup from "yup";

import { useFormik } from "formik";
import { useEffect } from "react";
import crossButton from "../assets/image/crossButton.svg";
import '../common/styles/changePassword.css'
import '../common/styles/createAdmin.css'
import { ColorTheme } from "../../constant/ColorTheme";
import { changePasswordRequest } from "../../redux/actionDispatcher/auth/changePassDispatcher";
import { connect, useDispatch, useSelector } from "react-redux";
import LoaderButton from "../common/LoaderButton";
import { useNavigate } from "react-router-dom";
import { hideChangePassModal, showChangePassModal } from "../../redux/actionDispatcher/auth/changePassModalDispatcher";


function ChangePassword({ changePassword, changePasswordRequest }) {
    const dispatch = useDispatch();
    const isModalVisible = useSelector((state) => state.changePassModalReducer.isModalVisible);
    var navigate = useNavigate();
    const validationSchema = Yup.object({
        oldPassword: Yup.string()
            // .min(6, "Password must be at least 6 characters")
            .required("Please Enter Password"),

        newPassword: Yup.string()
            // .min(6, "Password must be at least 6 characters")
            .required("Please Enter Password"),

        confirmNewPassword: Yup.string()
            .min(6, "Password must be at least 6 characters")
            .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
            .required("Please Confirm Password"),
    });
    const formik = useFormik({
        initialValues: {
            oldPassword: "",
            newPassword: "",
            confirmNewPassword: "",
        },
        validationSchema,


        onSubmit: (values) => {
            // // console.log(values);
            const data = {
                confirm_new_password: formik.values.confirmNewPassword,
                new_password: formik.values.newPassword,
                old_password: formik.values.oldPassword,
            };
            console.log(data);

            changePasswordRequest(data, navigate);
        },
    });

    useEffect(() => {
        console.log("Modal Visibility Changed:", isModalVisible);
    }, [isModalVisible]);
    useEffect(() => {

        // console.log(formik.errors);
    }, [formik.errors])
    return (<div>
        <CButton
            className="personal-setting-button button"
            onClick={() => dispatch(showChangePassModal())}
        >
            Change Password
        </CButton>
        <CModal
            alignment="center"
            visible={isModalVisible}
            onClose={() => {
                formik.handleReset();
                dispatch(hideChangePassModal());
            }}
        >
            <CModalBody className="my-modal-body" >
                <div className="main-container createAdmin ">
                    <div className=" cross-btn-div d-flex ">
                        <img onClick={() => dispatch(hideChangePassModal())}
                            src={crossButton} alt="close" className="cross-button" />
                    </div>
                    <form onSubmit={formik.handleSubmit} className="login-form">

                        <div className="mb-4">
                            <h4 className="h4 fw-bold" style={{ color: ColorTheme.colors.primary }}> <b> Change Password </b></h4>
                        </div>
                        <div className="mb-3 input-login-box">
                            <input

                                value={formik.values.oldPassword}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                name="oldPassword"
                                type="password"
                                className="form-control login-input mt-3"
                                placeholder="Old Password"
                                disabled={changePassword.loading}
                            />


                            {formik.errors.oldPassword && formik.touched.oldPassword ? (
                                <div className="text-danger fs-6">{formik.errors.oldPassword}</div>
                            ) : (
                                ""
                            )}
                            <input

                                value={formik.values.newPassword}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                name="newPassword"
                                type="password"
                                className="form-control login-input mt-3"
                                placeholder="New Password"
                                disabled={changePassword.loading}
                            />
                            {formik.errors.newPassword && formik.touched.newPassword ? (
                                <div className="text-danger fs-6">{formik.errors.newPassword}</div>
                            ) : (
                                ""
                            )}
                            <input

                                value={formik.values.confirmNewPassword}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                name="confirmNewPassword"
                                type="password"
                                className="form-control login-input mt-3"
                                placeholder="Confirm New Password"
                                disabled={changePassword.loading}
                            />
                            {formik.errors.confirmNewPassword && formik.touched.confirmNewPassword ? (
                                <div className="text-danger fs-6">{formik.errors.confirmNewPassword}</div>
                            ) : (
                                ""
                            )}
                        </div>


                        <button
                            className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
                            type="submit"
                            onClick={console.log('clciked ')}
                            disabled={changePassword.loading}
                        >
                            {/* used loader for button here ============= */}
                            {
                                changePassword.loading ? (<LoaderButton />) :

                                    "Submit"}
                        </button>

                    </form>
                </div>
            </CModalBody>
        </CModal>

    </div>);
}
const mapStateToProps = (state) => {
    return {
        changePassword: state.changePassword,
    };
};

//passing the changePassword in fetchUsers function and also dispatch method
const mapDispatchToProps = (dispatch) => {
    return {
        changePasswordRequest: (data, navigate) => dispatch(changePasswordRequest(data, navigate)),
    };
};

//Connecting the component to our store
export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
